import { useVendorSubscriptionFeatures } from '../services/subscriptionService';

/**
 * Backward-compatible wrapper — uses the shared React Query cache (no duplicate fetches).
 */
const useSubscriptionStatus = () => {
  const {
    hasActiveSubscription,
    isChecking,
    checkSubscriptionStatus,
    refreshSubscriptionStatus,
  } = useVendorSubscriptionFeatures();

  return {
    hasActiveSubscription,
    isChecking,
    checkSubscriptionStatus,
    refreshSubscriptionStatus,
  };
};

export default useSubscriptionStatus;
